<template>
    <teleport to="body">
        <app-crop-image
            v-if="cropper"
            :image="stepForm.player_image"
            :stencil-props="{
                aspectRatio: 10 / 10
            }"
            :min-width="100"
            :text="$trans('event.create.player_image_crop')"
            :min-height="100"
       
            :debounce="100"
            @close="closeCrop"
            @crop="cropFinish"
            @change="cropChange"
        />
    </teleport>
    <div class="branding-details">
        <div class="event-padding">
            <div class="form-group">
                <app-input
                    :label="$trans('event.create.player_name_label')"
                    :error="errors.get('player_name')"
                    v-model="stepForm.player_name"
                    :placeholder="$trans('event.create.player_name')"
                >
                </app-input>
            </div>
            <div class="form-group">
                <div class="branding-logo-items">
                    <input
                        type="file"
                        ref="playerLogo"
                        @input="playerLogoSelect"
                    />
                    <div
                        class="branding-logo"
                        :class="{
                            uploading: uploadingImage,
                            'has-image': stepForm.player_image
                        }"
                        @click="uploadPlayerLogo"
                    >
                        <span
                            class="branding-logo-cancel"
                            @click.stop="cancelPlayerLogo"
                            v-html="$icon('cancel-filled')"
                            v-if="stepForm.player_image"
                        ></span>
                        <img
                            class="player-image"
                            :src="stepForm.player_image"
                            v-if="stepForm.player_image"
                            alt=""
                        />
                        <span
                            v-if="!stepForm.player_image"
                            class="branding-icon"
                            v-html="$icon('upload')"
                        ></span>
                        <span
                            v-if="!stepForm.player_image"
                            class="branding-text"
                            v-html="$trans('event.create.player_logo')"
                        ></span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <app-textarea
                    :error="errors.get('player_description')"
                    v-model="stepForm.player_description"
                    :placeholder="$trans('event.create.player_description')"
                >
                </app-textarea>
            </div>
            <div class="form-group">
                <div class="flex-items force">
                    <div class="flex-item">
                        <app-input
                            :error="errors.get('player_business_phone')"
                            start-icon="phone"
                            v-model="stepForm.player_business_phone"
                            :placeholder="
                                $trans('event.create.player_business_phone')
                            "
                        >
                        </app-input>
                    </div>
                    <div class="flex-item">
                        <app-input
                            :error="errors.get('player_phone')"
                            start-icon="phone"
                            v-model="stepForm.player_phone"
                            :placeholder="$trans('event.create.player_phone')"
                        >
                        </app-input>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="flex-items">
                    <div class="flex-item">
                        <app-input
                            :error="errors.get('player_email')"
                            start-icon="email"
                            v-model="stepForm.player_email"
                            :placeholder="$trans('event.create.player_email')"
                        >
                        </app-input>
                    </div>
                    <div class="flex-item">
                        <app-input
                            :error="errors.get('player_email_2')"
                            start-icon="email"
                            v-model="stepForm.player_email_2"
                            :placeholder="$trans('event.create.player_email_2')"
                        >
                        </app-input>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="flex-items">
                    <div class="flex-item">
                        <app-input
                            :error="errors.get('player_address')"
                            start-icon="location"
                            :address="true"
                            :short-address="true"
                            v-model="stepForm.player_address"
                            :placeholder="$trans('event.create.player_address')"
                        >
                        </app-input>
                    </div>
                </div>
            </div>
            <div
                v-for="(link, index) in stepForm.player_links"
                :key="index"
                class="form-group small-group"
            >
                <div class="flex-items force">
                    <div class="flex-item-auto w-65">
                        <app-input
                            :key="index"
                            :error="errors.get(`player_links.${index}.url`)"
                            v-model="link.url"
                            icon="cancel"
                            :icon-clickable="true"
                            @click="removePlayerLink(index)"
                            start-icon="link"
                            :placeholder="$trans('event.create.player_link')"
                        >
                        </app-input>
                    </div>
                    <div class="flex-item-auto w-35">
                        <app-select
                            :error="errors.get(`player_links.${index}.type`)"
                            v-model="link.type"
                        >
                            <option
                                v-for="(label, option) in constants.linkTypes"
                                :value="option"
                                :key="option"
                                >{{ label }}</option
                            >
                        </app-select>
                    </div>
                </div>
            </div>
            <div class="add-player-link" @click="addPlayerLink">
                + {{ $trans("event.create.add_player_link") }}
            </div>
        </div>
    </div>
</template>

<script>
import step from "../../../mixins/step";

import { nextTick } from "vue";

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
    name: "BrandingDetails",
    emits: ["pushState"],
    components: { Cropper },
    mixins: [step],
    data() {
        return {
            uploadingImage: false,
            cropper: false
        };
    },
    mounted() {
        // window.eventBus.on("beforeStepSave", step => {
        //     if (step === 0) {
        //         if (this.cropper) {
        //             const cropValues = this.cropper.getValue();
        //             this.resizeImage(
        //                 this.stepForm.player_image,
        //                 cropValues.width,
        //                 cropValues.height,
        //                 cropValues.x,
        //                 cropValues.y,
        //                 image => {
        //                     document
        //                         .querySelector(".user-avatar img")
        //                         .setAttribute("src", image);
        //                     this.stepForm.player_image = image;
        //                 }
        //             );
        //         }
        //     }
        // });
    },
    methods: {
        closeCrop() {
            this.cropper = false;
            this.stepForm.player_image = false;
        },
        cropChange(data) {
            if (data.image) {
                nextTick(() => {
                    this.resizeImage(
                        data.image.src,
                        data.coordinates.width,
                        data.coordinates.height,
                        data.coordinates.left,
                        data.coordinates.top,
                        image => {
                            this.stepForm.player_image = image;
                        }
                    );
                });
            }
        },
        cropFinish(data) {
            if (data.image) {
                nextTick(() => {
                    this.resizeImage(
                        data.image.src,
                        data.coordinates.width,
                        data.coordinates.height,
                        data.coordinates.left,
                        data.coordinates.top,
                        image => {
                            document
                                .querySelector(".user-avatar img")
                                .setAttribute("src", image);
                            this.stepForm.player_image = image;

                            this.cropper = false;
                        }
                    );
                });
            }
        },
        resizeImage(url, width, height, x, y, callback) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            var imageObj = new Image();

            // set canvas dimensions

            canvas.width = width;
            canvas.height = height;

            imageObj.onload = function() {
                context.drawImage(
                    imageObj,
                    x,
                    y,
                    width,
                    height,
                    0,
                    0,
                    width,
                    height
                );
                callback(canvas.toDataURL());
            };

            imageObj.src = url;
        },
        addPlayerLink() {
            this.stepForm.player_links = [
                ...this.stepForm.player_links,
                ...[
                    {
                        type: "website",
                        url: ""
                    }
                ]
            ];
        },
        removePlayerLink(index) {
            this.stepForm.player_links.splice(index, 1);
        },
        uploadPlayerLogo() {
            this.$refs.playerLogo.click();
        },
        cancelPlayerLogo() {
            if (this.cropper) {
                nextTick(() => {
                    this.cropper = false;
                    this.uploadingImage = false;

                    this.stepForm.player_image = "";
                    this.$refs.playerLogo.value = "";
                });
                return;
            }

            this.stepForm.player_image = "";
            this.$refs.playerLogo.value = "";

            const defaultImg = document
                .querySelector(".user-avatar img")
                .getAttribute("data-default");

            document
                .querySelector(".user-avatar img")
                .setAttribute("src", defaultImg);
        },
        async playerLogoSelect(e) {
            this.stepForm.player_image = "";

            const file = e.target.files[0];

            if (!file) {
                return;
            }

            this.uploadingImage = true;

            const response = await this.$api.postFile("upload-image", file);

            this.uploadingImage = false;

            if (response.hasErrors()) {
                this.$refs.playerLogo.value = "";
                this.toast.error(
                    this.$trans("event.create.validation_error"),
                    response.errors().get("file")
                );
                return;
            }

            const reader = new FileReader();

            reader.onload = e => {
                this.stepForm.player_image = e.target.result;
                this.cropper = true;
            };

            reader.readAsDataURL(file);
        }
    }
};
</script>
